import { render } from "./CustomerMenuMobile.vue?vue&type=template&id=5e32bd15&scoped=true"
import script from "./CustomerMenuMobile.vue?vue&type=script&lang=js"
export * from "./CustomerMenuMobile.vue?vue&type=script&lang=js"

import "./CustomerMenuMobile.vue?vue&type=style&index=0&id=5e32bd15&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e32bd15"]])

export default __exports__